// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2mQEG","footer":"ReportModalFilter_footer__3AftM"};